export enum EPostCategories {
  BLOG = "Blog",
  EVENT = "Event",
}
